<template>
  <div class="criterio-select-lojas">
    <v-row>
      <v-col class="py-0" align="center">
        <select-dynamic-attributes-dialog
          :dynamic-attributes="dynamicAttributes"
          :selected-dynamic-attribute.sync="selectedDynamicAttribute"
          :loading="loadingInitialState"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import { QUERY_DYNAMIC_ATTRIBUTES } from '@/modules/clientes/segmentation/graphql'
import { mapState } from 'vuex'
import SelectDynamicAttributesDialog from './SelectDynamicAttributesDialog.vue'

export default {
  components: { SelectDynamicAttributesDialog },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Object, Number],
      default: () => {
        return {}
      },
    },
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data: () => ({
    selectedDynamicAttribute: {},
    dynamicAttributes: [],
    loadingInitialState: false,
  }),

  computed: {
    ...mapState({}),
    tooltipPrimaryButton() {
      return this.disableSave
    },
    tooltipPrimaryButtonMessage() {
      return this.disableSave ? 'Não é possível alterar um segmento estático' : ''
    },
  },

  watch: {
    selectedDynamicAttribute(selectedDynamicAttribute) {
      const formattedValue = {
        _id: selectedDynamicAttribute._id,
        attribute: selectedDynamicAttribute.attribute,
        label: selectedDynamicAttribute.label,
        type: selectedDynamicAttribute.type,
      }
      const selectedChild = this.getSelectedChildForDynamicAttribute(selectedDynamicAttribute)
      this.$emit('input', {
        currentValue: formattedValue,
        currentChildren: selectedChild,
        currentIndex: this.currentIndex,
        affectsChildren: true,
        forceReloadChildren: true,
      })
      this.validate()
    },
  },

  async mounted() {
    await this.queryDynamicAttributes()
    if (!isEmpty(this.initialValue)) {
      this.setInitialState(this.initialValue)
    }
    this.validate()
  },

  methods: {
    getSelectedChildForDynamicAttribute(selectedDynamicAttribute) {
      const childIndex = this.componentParams?.dynamicAttributeTypeToChild?.[selectedDynamicAttribute.type] || 0
      return this.values[childIndex]
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return !isEmpty(this.selectedDynamicAttribute)
    },

    async queryDynamicAttributes() {
      try {
        this.loadingInitialState = true
        const {
          data: {
            dynamicAttributes: { dynamicAttributes },
          },
        } = await this.$apollo.query({
          query: QUERY_DYNAMIC_ATTRIBUTES,
        })
        this.dynamicAttributes = dynamicAttributes
      } catch {
        this.$snackbar({ message: 'Falha ao comunicar com o servidor.' })
      }
      this.loadingInitialState = false
    },

    setInitialState(selectedDynamicAttribute) {
      this.selectedDynamicAttribute = selectedDynamicAttribute
    },
  },
}
</script>

<style lang="scss">
.criterio-select-lojas {
  .select-container {
    padding: 0 15px;
  }
}
</style>
